// extracted by mini-css-extract-plugin
export default {"modal":"SignupDetails_modal__XOWys","signupDetailsMain":"SignupDetails_signupDetailsMain__2rVYN","signupDetailsBody":"SignupDetails_signupDetailsBody__VZxbu"};